/**
 * The one page sign-in is allowed to return to.
 *
 * Everything else lands on the overview after signing in -- that is
 * deliberate. Connect Miro is the exception: Miro's consent page sends people
 * back to it with a one-time code, and a code dropped on the way is a
 * connection that has to be started again. The panel opens this page too,
 * when it is not connected yet.
 */
export const CONNECT_PATH = '/connect-miro'

/** The pages sign-in may return to, address and all. */
export function returnsAfterSignIn(path: string): boolean {
  return path.startsWith(CONNECT_PATH)
}
